import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Icon from '../../../../Icons'
import { selectActiveBuilding } from '../../../../../reducers/buildingSelectorReducer'
import { getServiceTypeIcon, getLinkTypeName } from '../../helpers'
import API from '../../../../../api/api'

import SocialLinkForm from './SocialLinkForm'

const Links = ({ buildingId }) => {
  const { t } = useTranslation(['social-link'])
  const [isLinkFormVisible, setLinkFormVisible] = useState(false)
  const [socialLinksData, setSocialLinksData] = useState([])
  const [selectedLinkData, selectLinkData] = useState(null)

  const fetchLinks = (id) => {
    API.fetchSocialLinks(id).then((response) => {
      setSocialLinksData(response.data)
    })
  }

  useEffect(() => {
    if (buildingId) fetchLinks(buildingId)
  }, [buildingId])

  useEffect(() => {
    if (selectedLinkData) setLinkFormVisible(true)
  }, [selectedLinkData])

  return (
    <div className="links-wrapper">
      {buildingId ? (
        <button className="button button-primary" onClick={() => setLinkFormVisible(true)}>
          {t('social-link:links.addNewButton')}
        </button>
      ) : null}
      <div className="links-body">
        {socialLinksData.map((linkData) => {
          return (
            <div key={linkData.id} className="link-wrapper">
              <img src={getServiceTypeIcon(linkData.service)} />
              <div className="link-data-info-container">
                <div>{getLinkTypeName(linkData.service)}</div>
                <div>{linkData.link}</div>
              </div>
              <div className="edit-icon-container" onClick={() => selectLinkData(linkData)}>
                <Icon icon="editPen" viewBox="3 3 20 20" />
              </div>
            </div>
          )
        })}
      </div>
      {isLinkFormVisible && (
        <SocialLinkForm
          buildingId={buildingId}
          refreshList={fetchLinks}
          previewData={selectedLinkData}
          existingSocialServices={socialLinksData.map((link) => link.service)}
          handleCancel={() => {
            selectLinkData(null)
            setLinkFormVisible(false)
          }}
        />
      )}
    </div>
  )
}

Links.propTypes = {
  buildingId: PropTypes.number,
}

export default connect((state) => {
  const building = selectActiveBuilding(state)
  return {
    buildingId: building ? building.id : null,
  }
})(Links)
